<script lang="ts">
    import { get } from 'svelte/store';
    import { z } from 'zod';

    import TelematicsFilter from '../components/telematics/TelematicsFilter.svelte';
    import { api, jobs_filter_config } from '../../stores/api';
    import { FilterManagerIO } from '../components/telematics/components/FilterByParameters/FilterManagerIO';
    import { SettingsApi } from '../components/Settings/SettingsApi';
    import { type localStorageFilterType } from '../components/telematics/components/FilterByParameters/FilterManager';
    import type { QueriesType } from '../components/telematics/types';
    import type { LastMileConfigResponseType } from '../components/Settings/settings';

    export let collectionName: string;
    export let enableInactiveQueries: boolean = true;
    export let filterManagerStorageKey: string | null = null;
    export let filterConfig: LastMileConfigResponseType | null;
    export let showQuickFilters: boolean = false;
    //export let queries: QueriesType;
    export let andOrSelectionEnabled: boolean = false;
    export let visibleFilterIcon: boolean = true;
    export let filterManagerIO: FilterManagerIO | null = null;
    export let filteredCount: number = 0;
    export let totalCount: number = 0;
    export let makeBlured: boolean = false;
    export let showButtonRemoveAll: boolean = true;
    export let showButtonAddFilter: boolean = true;
    export let showButtonRestoreFilter: boolean = true;

    export let onChange: (
        queries: QueriesType,
        andOrSelection: string,
        allQueries: QueriesType,
        changed: boolean
    ) => void;

    //let queriesCopy: QueriesType;
    let forceReload: boolean = false;

    if (!filterManagerIO && filterManagerStorageKey) {
        filterManagerIO = new FilterManagerIO(
            async () => {
                let data = await SettingsApi.getClientSettings<localStorageFilterType>(
                    get(api),
                    filterManagerStorageKey || '',
                    z.any()
                );
                console.log('TelematicsFilter, load', data);
                return data;
            },
            async data => {
                console.log('TelematicsFilter, save', data);
                await SettingsApi.setClientSettings<localStorageFilterType>(
                    get(api),
                    filterManagerStorageKey || '',
                    data,
                    z.any()
                );
            }
        );
    }

    export function updateFilters(queries: QueriesType, withLoad: boolean = true): void {
        let filterQueries = convertQueriesToTelematicsFilter(queries);
        if (withLoad) {
            filterManagerIO?.load().then(data => {
                if (Array.isArray(data.mainFilterData.queries)) {
                    data.mainFilterData.queries = {};
                }
                data.mainFilterData.queries = Object.assign(
                    data.mainFilterData.queries,
                    filterQueries
                );
                filterManagerIO?.save(data).then(() => {
                    forceReload = !forceReload;
                });
            });
        }
    }

    function convertQueriesToTelematicsFilter(queries: QueriesType): QueriesType {
        let queriesCopy = JSON.parse(JSON.stringify(queries));
        // if (queriesCopy.geom) {
        //     queriesCopy.geom = {'$geoWithin': {'$geometry': queriesCopy.geom}};
        // }
        return queriesCopy;
    }

    function convertTelematicsFilterToQueries(queries: QueriesType): QueriesType {
        let queriesCopy = JSON.parse(JSON.stringify(queries));
        if (queriesCopy.geom) {
            // queriesCopy.geom = queriesCopy.geom['$geoWithin']?.['$geometry'];
            if (!queriesCopy.geom) {
                delete queriesCopy.geom;
            }
        }
        return queriesCopy;
    }

    $: {
        forceReload = forceReload;
    }
</script>

<TelematicsFilter
    {collectionName}
    onChange={(queries, andOrSelection, allQueries, changed) => {
        onChange(convertTelematicsFilterToQueries(queries), andOrSelection, allQueries, changed);
    }}
    {showQuickFilters}
    {filterConfig}
    {enableInactiveQueries}
    {filterManagerIO}
    {andOrSelectionEnabled}
    {visibleFilterIcon}
    bind:forceReload
    {filteredCount}
    {totalCount}
    {makeBlured}
    {showButtonRemoveAll}
    {showButtonAddFilter}
    {showButtonRestoreFilter}
/>
